document.addEventListener("DOMContentLoaded", function () {

    var hash = window.location.hash;

    openFaqItem(hash);

    $('.accordion-item').on('click', function (event) {

        const data_anchor = $(event.target).data('anchor');
        
        // Internal link to another faq item requires extra handling
        if ( data_anchor ) {
            var hash = data_anchor;

            openFaqItem(hash);
        }

        // Update hash in url without triggering the automatic scroll to the element
        history.pushState(null, null, '#' + $(this).attr('id'));

    });

});


function openFaqItem(faq_id) {

    if (faq_id) {

        var faq_item = $(faq_id+" > a")
        if (faq_item) {

            const elementPosition = faq_item[0].getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: elementPosition - 200,
                behavior: 'smooth'
            });
            faq_item[0].click();

        }

    }

}